

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import urlApi from '../actions/urlApi';
import { RequestProps } from 'shared/components/CommentsController/const/types';
import { Nullable, PageModel, Tag } from '@brg/api';
import { INITIAL_REQUEST_FILTER } from 'shared/components/CommentsController/const/const';

export const fetchFeedTags = createAsyncThunk('chat/fetchFeedTags', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId, page, limit, lang, offset = 0 } = args;
    const { tags } = getState().feedTags;
    const res = await urlApi().fetchFeedTags({ accountId, page, limit, offset })

    return res
});

export const fetchMoreFeedTags = createAsyncThunk('chat/fetchMoreFeedTags', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId, page, limit, lang, offset } = args;
    const { tags } = getState().feedTags;
    const res = await urlApi().fetchFeedTags({ accountId, page, limit, offset})

    return {
        paging: res.paging,
        data: [...(tags?.data || []), ...res.data]
    }
});

export interface FeedTagsState {
    tags: PageModel<Tag> ;
    loading: boolean;
    filter: RequestProps;
}

const INITIAL_STATE = {
    tags: {},
    loading: false,
    filter: INITIAL_REQUEST_FILTER,
}

const feedTagsSlice = createSlice({
    name: 'feedTags',
    initialState: INITIAL_STATE,
    reducers: {
        reset: (state) => {
            state = INITIAL_STATE;
        }
    },
    extraReducers: {
        [fetchFeedTags.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.tags = action.payload;
        },
        [fetchFeedTags.rejected.toString()]: (state) => {
            state.loading = false;
            state.tags = {};
        },
        [fetchFeedTags.pending.toString()]: (state) => {
            state.loading = true;
        },
        [fetchMoreFeedTags.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.tags = action.payload;
        },
        [fetchMoreFeedTags.rejected.toString()]: (state) => {
            state.loading = false;
            state.tags = {};
        },
        [fetchMoreFeedTags.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default feedTagsSlice;
export const chatSliceReducer = feedTagsSlice.reducer;
export const getFeedTags = (store: { feedTags: FeedTagsState }): FeedTagsState => store.feedTags;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import urlApi from '../actions/urlApi';
import { RequestProps } from 'shared/components/CommentsController/const/types';
import { Nullable, PageModel, Tag } from '@brg/api';
import { INITIAL_REQUEST_FILTER } from 'shared/components/CommentsController/const/const';

export const fetchFeedTags = createAsyncThunk('chat/fetchFeedTags', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId, page, limit, lang, offset = 0 } = args;
    const { tags } = getState().feedTags;
    const res = await urlApi().fetchFeedTags({ accountId, page, limit, offset })

    return res
});

export const fetchMoreFeedTags = createAsyncThunk('chat/fetchMoreFeedTags', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId, page, limit, lang, offset } = args;
    const { tags } = getState().feedTags;
    const res = await urlApi().fetchFeedTags({ accountId, page, limit, offset})

    return {
        paging: res.paging,
        data: [...(tags?.data || []), ...res.data]
    }
});

export interface FeedTagsState {
    tags: PageModel<Tag> ;
    loading: boolean;
    filter: RequestProps;
}

const INITIAL_STATE = {
    tags: {},
    loading: false,
    filter: INITIAL_REQUEST_FILTER,
}

const feedTagsSlice = createSlice({
    name: 'feedTags',
    initialState: INITIAL_STATE,
    reducers: {
        reset: (state) => {
            state = INITIAL_STATE;
        }
    },
    extraReducers: {
        [fetchFeedTags.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.tags = action.payload;
        },
        [fetchFeedTags.rejected.toString()]: (state) => {
            state.loading = false;
            state.tags = {};
        },
        [fetchFeedTags.pending.toString()]: (state) => {
            state.loading = true;
        },
        [fetchMoreFeedTags.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.tags = action.payload;
        },
        [fetchMoreFeedTags.rejected.toString()]: (state) => {
            state.loading = false;
            state.tags = {};
        },
        [fetchMoreFeedTags.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default feedTagsSlice;
export const chatSliceReducer = feedTagsSlice.reducer;
export const getFeedTags = (store: { feedTags: FeedTagsState }): FeedTagsState => store.feedTags;
